module.exports = __webpack_public_path__ + "ai-bot-body-normalwp30a25e900cc1045c975fc4ec8ee86f83.png";